import { useEffect } from "react"
import { useAtom } from "jotai"
import { loginDialogAtom } from "../atoms/login"
import { Dialog, DialogContent, DialogTitle } from "~/components/ui/dialog"
import { LoginStep1 } from "./login-step-1"
import { LoginStep2 } from "./login-step-2"

export function LoginDialog() {
  const [state, setState] = useAtom(loginDialogAtom)

  // Reset on mount so re-opening after logout always shows step 1
  useEffect(() => {
    setState({ step: 1, phone: "" })
  }, [])

  return (
    <Dialog open={true}>
      <DialogContent showCloseButton={false}>
        <DialogTitle className="sr-only">Вход</DialogTitle>
        {state.step === 1 ? <LoginStep1 /> : <LoginStep2 />}
      </DialogContent>
    </Dialog>
  )
}
